import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function GuideBusiness() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            よくある質問
          </Typography>
          <dl>
            <dt>地元出身ではありませんが、採用に影響しますか？</dt>
            <dd>
              出身地が採用に影響することはありません。
            </dd>
            <dt>デーリー東北の読者はどのぐらいいるんですか？</dt>
            <dd>
              ●現在、約９万２千部を発行しています。本社のある八戸市では、新聞を購読している世帯の８０％以上がデーリー東北です。
            </dd>
            <dt>転勤はありますか？</dt>
            <dd>
              編集、営業部門では転勤があります。各地に支社、総局、支局があり、数年単位で異動することが多いです。
            </dd>
            <dt>休日はきちんと取れますか？</dt>
            <dd>
              取得できます。休日出勤した場合などは代休を取るなどして対応しています。
            </dd>
            <dt>新聞記者になるのに資格はいりますか？</dt>
            <dd>
              特別な資格は必要ありませんが、自動車免許は必要です。
            </dd>
            <dt>仕事は何時ぐらいに終わりますか？</dt>
            <dd>
              新聞社には様々な職場があり、部署によって就業時間も様々です。通常の日勤は、午前９時半始業、午後５時半が就業時間になっていますが、外勤記者とグラフィックデザイナーの部署は、フレックス制を採用していますので、仕事の状況に応じて、退勤時間を決められます。他に、夕方出勤、夜勤の職場などもあります。
            </dd>
            <dt>新聞社は文系のイメージがありますが、理系出身だと難しいでしょうか？</dt>
            <dd>
              どの部署であっても、出身学部が採用に影響することはありません。実際、当社では、さまざまな学部の出身者が勤務しています。ただ、部署によっては、専門的な知識が求められることがあります。
            </dd>
            <dt>文章が苦手ですが、記者になれますか？</dt>
            <dd>
              新聞社には、記者の原稿を直したり、指示を出したりする担当記者（デスク）がいます。<br />
              原稿の書き方は入社後、丁寧に指導しますので問題ありません。
            </dd>
            <dt>異業種で社会人経験がありますが、入社試験を受けられますか？</dt>
            <dd>
            弊社では、社会人採用を通年で実施しています。<br />
            ＨＰの採用情報をご覧いただくか、総務部の採用担当までお問い合わせください。
            </dd>
            <dt>希望する部署にいけますか？</dt>
            <dd>
              キャリアや適性などを総合的に考え、人事異動を行っていますので、必ず本人の希望が通るわけではありませんが、仕事に対する姿勢が認められれば、何年後かに希望部署に移る可能性は十分あります。
            </dd>
          </dl>
        </Box>


      </div>
    </div>
  );
}

export default GuideBusiness;
